import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonLink, ButtonExternal } from '../ui/Button';
import { PhotoFrame } from '../ui/PhotoFrame';
import { DoodleSquiggle } from '../brand/Doodles';
import { libraryPhotos, photoAlbums } from '../../data/photos';
import { externalLinks } from '../../data/site';

// Balanced 4-up mosaic: wide photos span two columns at a 2:1 ratio so they sit
// flush with the square photos beside them at every breakpoint.
const mosaic = libraryPhotos.slice(0, 6);
export function PhotoMosaic() {
  return <Section className="bcm-paper overflow-hidden py-16 sm:py-20" labelledBy="gallery-heading" data-id="element-195" data-mp="1s3sp6kbp9vsl">
      <Container data-id="element-196" data-mp="1nag6srxm6l8a">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-197" data-mp="1n9y011dbsom4">
          <div className="max-w-xl" data-id="element-198" data-mp="1ib3fnuzpmrzw">
            <h2 id="gallery-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-[2.75rem]" data-id="element-199" data-mp="2ft3mtsxr7a2i">
              Life at BCM
            </h2>
            <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-200" data-mp="3id0o381gr2sa">
              Worship nights, campus outreach, recreation, community groups, and the moments in
              between.
            </p>
          </div>
          <DoodleSquiggle className="hidden h-8 w-32 shrink-0 sm:block" color="var(--bcm-dark-blue)" data-id="element-201" data-mp="39ichnek5jf1w" />
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-202" data-mp="2zm95dfvl6018">
          {mosaic.map((photo, index) => {
          const isWide = index === 0 || index === 3;
          return <PhotoFrame key={photo.id} photo={photo} ratio={isWide ? 'aspect-[2/1]' : 'aspect-square'} className={isWide ? 'col-span-2' : ''} data-id="element-203" data-mp="2qlkpsgqjnrm8" data-mpi={index} />;
        })}
        </div>

        <ul className="mt-6 space-y-1.5" data-id="element-204" data-mp="oupqhex4paar">
          {photoAlbums.map(album => <li key={album.name} className="font-meta text-[12.5px] text-ink" data-id="element-205" data-mp="suzyex4heas9">
              <span className="font-semibold text-brand-navy" data-id="element-206" data-mp="21tj9603nwndo">{album.name}</span> — {album.status}.{' '}
              {album.note}
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-207" data-mp="1sribx38fi1c0">
          <ButtonLink to="/photos" data-id="element-208" data-mp="1stw6zc33zdjk">View BCM Photos</ButtonLink>
          <ButtonExternal href={externalLinks.photoAlbum} variant="secondary" data-id="element-209" data-mp="1ntqmcfv9araz">
            Open Full Photo Album
          </ButtonExternal>
        </div>
      </Container>
    </Section>;
}